module.exports = "button {\n    margin-left: 0px;\n}\n\nh1 {\n    font-size: 1.2em;\n    padding: 0px;\n    margin: 0px;\n    font-weight: 800;\n}\n\n.error {\n    margin-left: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation-login/navigation-login.component.css
// module id = ./src/app/navigation-login/navigation-login.component.css
// module chunks = main